__turbopack_context__.v({
  "blocksBackgroundColor": "ListItemGroup-module-scss-module__wIktPq__blocksBackgroundColor",
  "blocksFontColor": "ListItemGroup-module-scss-module__wIktPq__blocksFontColor",
  "contentContainer": "ListItemGroup-module-scss-module__wIktPq__contentContainer",
  "contentItemDate": "ListItemGroup-module-scss-module__wIktPq__contentItemDate",
  "curationContainer": "ListItemGroup-module-scss-module__wIktPq__curationContainer",
  "date": "ListItemGroup-module-scss-module__wIktPq__date",
  "dateContainer": "ListItemGroup-module-scss-module__wIktPq__dateContainer",
  "dateLocationContainer": "ListItemGroup-module-scss-module__wIktPq__dateLocationContainer",
  "dateMedia": "ListItemGroup-module-scss-module__wIktPq__dateMedia",
  "description": "ListItemGroup-module-scss-module__wIktPq__description",
  "descriptionNoTitle": "ListItemGroup-module-scss-module__wIktPq__descriptionNoTitle",
  "descriptionWithPrompt": "ListItemGroup-module-scss-module__wIktPq__descriptionWithPrompt",
  "discussionPrompt": "ListItemGroup-module-scss-module__wIktPq__discussionPrompt",
  "expandButton": "ListItemGroup-module-scss-module__wIktPq__expandButton",
  "groupContainer": "ListItemGroup-module-scss-module__wIktPq__groupContainer",
  "groupContainerCenteredImage": "ListItemGroup-module-scss-module__wIktPq__groupContainerCenteredImage",
  "groupContainerNews": "ListItemGroup-module-scss-module__wIktPq__groupContainerNews",
  "header": "ListItemGroup-module-scss-module__wIktPq__header",
  "item": "ListItemGroup-module-scss-module__wIktPq__item",
  "itemHidden": "ListItemGroup-module-scss-module__wIktPq__itemHidden",
  "joinTheDiscussionContainer": "ListItemGroup-module-scss-module__wIktPq__joinTheDiscussionContainer",
  "joinTheDiscussionFullText": "ListItemGroup-module-scss-module__wIktPq__joinTheDiscussionFullText",
  "joinTheDiscussionShortText": "ListItemGroup-module-scss-module__wIktPq__joinTheDiscussionShortText",
  "meritChatCallout": "ListItemGroup-module-scss-module__wIktPq__meritChatCallout",
  "orgTitle": "ListItemGroup-module-scss-module__wIktPq__orgTitle",
  "organizationTitle": "ListItemGroup-module-scss-module__wIktPq__organizationTitle",
  "parentsquareLink": "ListItemGroup-module-scss-module__wIktPq__parentsquareLink",
  "secondaryNavBackgroundColor": "ListItemGroup-module-scss-module__wIktPq__secondaryNavBackgroundColor",
  "shake": "ListItemGroup-module-scss-module__wIktPq__shake",
  "sourceIcon": "ListItemGroup-module-scss-module__wIktPq__sourceIcon",
  "sourceIconCalendar": "ListItemGroup-module-scss-module__wIktPq__sourceIconCalendar",
  "sourceIconError": "ListItemGroup-module-scss-module__wIktPq__sourceIconError",
  "sourceIconFacebook": "ListItemGroup-module-scss-module__wIktPq__sourceIconFacebook",
  "sourceIconGoogle": "ListItemGroup-module-scss-module__wIktPq__sourceIconGoogle",
  "sourceIconInstagram": "ListItemGroup-module-scss-module__wIktPq__sourceIconInstagram",
  "sourceIconParentsquare": "ListItemGroup-module-scss-module__wIktPq__sourceIconParentsquare",
  "sourceIconPinterest": "ListItemGroup-module-scss-module__wIktPq__sourceIconPinterest",
  "sourceIconRss": "ListItemGroup-module-scss-module__wIktPq__sourceIconRss",
  "sourceIconTripadvisor": "ListItemGroup-module-scss-module__wIktPq__sourceIconTripadvisor",
  "sourceIconTwitter": "ListItemGroup-module-scss-module__wIktPq__sourceIconTwitter",
  "sourceIconVimeo": "ListItemGroup-module-scss-module__wIktPq__sourceIconVimeo",
  "sourceIconYelp": "ListItemGroup-module-scss-module__wIktPq__sourceIconYelp",
  "sourceIconYoutube": "ListItemGroup-module-scss-module__wIktPq__sourceIconYoutube",
  "themeBackgroundColor": "ListItemGroup-module-scss-module__wIktPq__themeBackgroundColor",
  "themeFontColor": "ListItemGroup-module-scss-module__wIktPq__themeFontColor",
  "themeFontFamily": "ListItemGroup-module-scss-module__wIktPq__themeFontFamily",
  "title": "ListItemGroup-module-scss-module__wIktPq__title",
  "titleContainer": "ListItemGroup-module-scss-module__wIktPq__titleContainer",
});
